import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import homeModule from './modules/home'
import loginModule from './modules/login'
import {
    ACCESS_TOKEN,
    UER_ROLE,
    USER_LEVEL,
    USER_NAME,
    USER_IMAGE,
    SYSTEM_IMAGE,
    SYSTEM_NAME,
    ORG_NAME,
    SET_LANG
} from './mutation-types'

Vue.use(Vuex)


const getters = {
    // 获取接入设备数的最大值
    // getMaxSold (state) {
    //     let tem = {
    //         sold: 0
    //     }
    //     state.mapData.forEach((item) => {
    //         if (item.sold > tem.sold) {
    //             tem = item
    //         }
    //     })
    //     return tem
    // },
    userId(state) {
        return state.user.id
    },
    username(state) {
        var username = state.user.name ? state.user.name : Vue.ls.get(USER_NAME)
        return username
    },
    userImage(state){
        var userImage = state.user.userImage ? state.user.userImage : Vue.ls.get(USER_IMAGE)
        return userImage
    },
    systemImage(state){
        let systemImage = state.org.systemImage ? state.org.systemImage : Vue.ls.get(SYSTEM_IMAGE)
        return systemImage
    },
    systemName(state){
        let systemName = state.org.systemName ? state.org.systemName : Vue.ls.get(SYSTEM_NAME)
        return systemName
    },
    orgName (state) {
      let orgName = state.org.orgName ? state.org.orgName : Vue.ls.get(ORG_NAME)
      return orgName
    },
    level(state) {
        return state.level ? state.level : Vue.ls.get(USER_LEVEL);
    },
    roles(state) {
        return state.user.roles ? state.user.roles : Vue.ls.get(UER_ROLE);
    },
    lang(state){
        return state.lang ? state.lang : Vue.ls.get(SET_LANG);
    },
    token(state) {
        if (state.token) {
            return state.token
        } else {
            // return Vue.ls.get(ACCESS_TOKEN)
            return localStorage.getItem(ACCESS_TOKEN)
        }
    },
    loggedIn(state) {
        var username = state.user.name ? state.user.name : Vue.ls.get(USER_NAME)
        var token = state.token ? state.token : localStorage.getItem(ACCESS_TOKEN)
        return !!(username && token) // eslint-disable-line
    },
    isSuperAdmin(state) {
        var username = state.user.name ? state.user.name : Vue.ls.get(USER_NAME)
        var roles = state.user.roles ? state.user.roles : Vue.ls.get(UER_ROLE)
        return !!(username && roles && roles.split(",").indexOf("SuperAdmin") != -1)
    },
    isIntegrator(state) {
        var username = state.user.name ? state.user.name : Vue.ls.get(USER_NAME)
        var roles = state.user.roles ? state.user.roles : Vue.ls.get(UER_ROLE)
        return !!(username && roles && roles.split(",").indexOf("Integrator") != -1)
    }
}

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
      home: homeModule,
      login: loginModule
    }
})
